export const MODAL_TIMEOUT = 500
export const DEBOUNCE_TIME = 500
export const STICKY_HEADER_SCROLL_TRIGGER = 47

export const LIMIT_AUTO_COMPLETE_SUGGESTIONS = 10

export const BASELINECSS_MATERIALUI = "materialui"
export const BASELINECSS_CUSTOM = "custom"

export const SUPPORTED_QUICKLINK_TYPES = Object.freeze({
    MyAccount: "MyAccount",
    Link: "link",
})

export const SUPPORTED_MY_ACCOUNT_TYPES = Object.freeze({
    loggedIn: "MyAccountLoggedIn",
    loggedOut: "MyAccountLoggedOut",
})

export enum TYPING_STATE {
    AUTO_COMPLETE = "AUTO_COMPLETE",
    RECENT_SEARCH = "RECENT_SEARCH",
    IDLE = "IDLE",
}

export enum QUICKLINK_TYPE {
    BUTTON = "btn",
    LINK = "link",
}

export enum BURGER_QUICKLINK_TYPE {
    MYACCOUNT = "MyAccount",
    FAVOURITES = "Favourites",
    LINKS = "Links",
    COUNTRYSELECTOR = "CountrySelector",
}

export enum EXCLUDE_FROM_TYPE {
    NARROWVIEW = "NarrowView",
    WIDEVIEW = "WideView",
}
export const EXCLUDE_FROM_WIDEVIEW_CLASS = "hideWideView"
export const EXCLUDE_FROM_NARROWVIEW_CLASS = "hideNarrowView"

export enum PRIMARY_NAV_ALIGNMENT_TYPES {
    EVENLY_SPREAD = "evenly-spread",
    CENTER_ALIGNED = "center-aligned",
    LEFT_ALIGNED = "left-aligned",
    RIGHT_ALIGNED = "right-aligned",
}

export enum NAV_VIEWTYPE {
    PRIMARY_NAVBAR_LINK = "primary-navbar-link",
    SECONDARY_NAVIGATION = "secondary-navigation",
}

export const SITE_URL_HEADER = "x-next-siteurl"
export const REALM_HEADER = "x-next-realm"
export const TERRITORY_HEADER = "x-next-territory"
export const LANGUAGE_HEADER = "x-next-language"
export const DEV_ESI_HEADER = "test-with-local-esi"
export const LOCALHOST = "localhost"

export type Anchor = "top" | "bottom" | "left" | "right"

export const MIN_NUMBER_CHAR_TO_SHOW_AUTOCOMPLETE = 3
export const COUNTRY_GB = "gb"
export const REGION_UK = "uk"
export const REGION_INTERNATIONAL = "international"

export const RPID_COOKIE = "RPId"

export const COUNTRY_SELECTOR_DRAWER_BREAKPOINT = "524px"

export const SOLD_OUT = "soldout"
export const IN_STOCK = "instock"

export const QUERY_PARAMETER_TIME_MACHINE_DATE = "time-machine-date"

export const CHEVRON_ICON_URL = "/icons/shared/chevron.svg"
export const CHEVRON_WHITE_ICON_URL = "/icons/shared/chevron-white-left.svg"
export const CLOSE_ICON_URL = "/icons/shared/close.svg"

export const SOFA_CATEGORY = "sofas"
export const IMAGE = "image"
export const UNDERSCORE = "_"

export const SOFA_CONTENT = "SofaContent"

export const COMMON_ITEM_IMAGE_URL = "/common/items/default/default/itemimages/altitembag/"
export const ITEM_ADD_TO_BAG_URL = "/Item_AddToBag/"
export const JPG = ".jpg"

export const DEFAULT_HEADER_FILE_NAME = "-header.json"
export const DEFAULT_ICON_FOLDER_VERSION = "v1"
export const DEFAULT_MEGANAV_API_VERSION = "v1"
export const DEFAULT_CDN_BASEURL = "https://cdn.platform.next/content"

export const BFPO = "bfpo"
export const ENGLISH_LANGUAGE_CODE = "en"

export const GTM_BLOOMREACH_INFO = "bloomreach"
export const GTM_MONETATE_INFO = "monetateEnabled"
export const GTM_UCM_INFO = "isUserConsentFeatureEnabled"
export const GTM_IS_UCM_ENABLED = "isUserConsentDatabaseEnabled"
export const BLOOMREACH_COOKIE_FULL_DOMAIN = "bloomreachCookieFullDomain"
export const GA_NEXT_TRACK_SIMPLE_EVENT = "GoogleAnalyticsNext.TrackSimpleEvent"
export const SEARCH_DATA_GA = "Search"
export const SEARCH_DATA_GA_RECENT_SEARCH = "Recent Search"
export const SEARCH_ICON_DATA_GA = "Press Icon"
export const OPEN_SEARCH_DATA_GA = "Open Search"
export const CLOSE_SEARCH_DATA_GA = "Close Search"
export const SEARCH_DELETE_CURRENT_SEARCH_DATA_GA = "Delete Current Search"
export const SEARCH_PREVIOUS_SEARCH_DATA_GA = "Previously Searched"
export const SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA = "Clear All Previous Search"
export const SEARCH_KEY_PRESS_ENTER_DATA_GA = "Key Press Enter"
export const HEADER_AUTOCOMPLETE_SEE_ALL_RESULTS_DATA_GA = "See All Results"
export const HEADER_AUTOCOMPLETE_LIST_ITEM_DATA_GA = "list"
export const HEADER_AUTOCOMPLETE_IMAGE_DATA_GA = "image"
export const COUNTRY_LANG_SELECTOR_DATA_GA = "Country Language"
export const COUNTRY_SELECT_DROPDOWN_DATA_GA = "Country Select"
export const GTM_UCM_CASED_TRUE = "True"

export const SEARCH_BLUR_BREAKPOINT = "768px"

export const HEADER_NAV_BAR_QUICK_LINKS = "Quick Links"
export const HEADER_NAV_BAR_QUICK_LINKS_SHOPPING_BAG = "Shopping bag"
export const HEADER_NAV_BAR_QUICK_LINKS_FAVOURITES = "Favourites"
export const HEADER_NAV_BAR_QUICK_LINKS_MY_ACCOUNT = "My Account"
export const HEADER_NAV_BAR_SHOPPING_BAG_VIEW_BAG = "View Bag"
export const HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT = "Checkout"
export const HEADER_NAV_BAR_HELP = "Help"
export const HEADER_NAV_BAR_STORE_LOCATOR = "Store Locator"

export const MY_ACCOUNT_URL = "/myaccount"
export const NO_FOLLOW = "nofollow"

export const NEXT_COOKIE = "NextConsentCookie"
export const NEXT_DEVICE_TYPE_COOKIE = "NextDeviceType"
export const NEXT_DIRECT_COOKIE = "NextDirectConsentCookie"
export const COOKIE_VALUE = "AllowCookiesFromNext=True"
export const SESSION_STORAGE_ACTIVE_DEPT_NAME = "PrimaryNavDeptSelector"
export const VISITED_PAGES = "VisitedPages"

export const RECENT_SEARCHES_COOKIE = "recentSearches"

export const BR_COOKIE_COOKIE_PARTS_LENGTH = 4
export const BR_COOKIE_COOKIE_UID_PARTS = 2
export const BR_COOKIE_COOKIE_UID_LENGTH = 2
export const BR_COOKIE_COOKIE_FULL_RANGE = 100

export const BR_COOKIE_COOKIE_NAME = "_br_mt_search"
export const BR_COOKIE_COOKIE_NUMBER_OF_DAYS = 1
export const BR_COOKIE_COOKIE_CACHING_ID = "_br_uid_2"
export const BR_SEARCH_VARIANT_COOKIE_NAME = "_br_seg_id"
export const BR_SEG_ID_UNCLASSIFIED = "unclassified"

export const TIME_MACHINE_DATE_COOKIE = "time-machine-date"
export const COUNTRY_SELECTOR_TYPING_DELAY_TIME = 2000

export const RPID = "RPID"
export const ACCOUNT_TYPE = "AcctType"
export const UNLIMITED_CUSTOMER = "unlimitedCustomer"

export const DEFAULT_TEMPLATE = "standard"
export const VARIANT_DEFAULT = "default"

export const PLP_ENTRYPOINT_ID = "next-plp-entrypoint"
export const TP_PAGE_IDENTIFIER = "[data-tp-page='true']"
export const CONTENT_AREA = "ContentArea"
export const MAIN_CONTENT = "mainContent"
export const PDP_ENTRYPOINT_ID = "tp-entrypoint"

export const SHOW_BACK_TO_COOKIE = "showBackToSiteBanner"
export const BACK_TO_URL_COOKIE = "backToSiteUrl"
export const BACK_TO_TP_CLIENT_COOKIE = "backToTpClient"

export const BACK_TO_SITE_CLIENT_PARAM = "fromsite"
export const BACK_TO_SITE_URL_PARAM = "fromsiteurl"
export const ENTRYPOINT_COOKIE_NAME = "x-next-realm-entrypoint"
export const ENTRYPOINT_HEADER_NAME = "x-next-realm-entrypoint"

export const MASID_COOKIE_NAME = "MASId"
export const MASID_COOKIE_SEGMENT_KEY_NAME = "PS1"
export const MASID_PERSONALISED_NAV_KEY_NAME = "NV1_"

export const DRAWER_RESET_HEIGHT_SCROLL_TRIGGER = 47
export const OVERLAY_TIMEOUT = 0
export const PRIMARY_NAV_ITEM_HOVER_DELAY = 300
export const PRIMARY_NAV_SCROLL_ANIMATION_DELAY = 400
export const PRIMARY_NAV_ITEM_ACTIVE_HOVER_DELAY = 50
export const DRAWER_GAP = 48
export const CHEVRON_WIDTH = 8
export const NAV_BAR = "Nav Bar"
// missing start
export const DEFAULT_PRIMARY_NAV_TYPE = "primary"
export const DEFAULT_SECONDARY_NAV_TYPE = "secondary"
export const DEFAULT_PRIMARY_NAV_VERSION = "v1.0.0"
export const DEFAULT_SECONDARY_NAV_VERSION = "v1.0.0"
// missing end
export const FULL_WIDTH_CONTAINER = "full-width-container"
export const PERSONALIZED_SECONDARY_NAVS = "personalised-secondary-navs"
export const LOWER_FULL_WIDTH_CONTAINER = "lower-full-width-container"
export const MISSION_BLOCK_DATA_GA = "Mission Block"

export const DEFAULT_IMAGE_PLACEHOLDER = "snail-default.png"
export const DEFAULT_IMAGE_PLACEHOLDER_2X = "snail-default-2x.png"
export const DEFAULT_IMAGE_PLACEHOLDER_3X = "snail-default-3x.png"

export const LTR = "ltr"
export const RTL = "rtl"
export const NEXT_DIRECT_PATH = "nextdirect"
export const SNAIL_TRAIL_CONTAINER = "snail-trail-container"
export const PLATFORM_MODERNISATION_HEADER = "platform_modernisation_header"
export const PLATFORM_MODERNISATION_HEADER_ID = `#${PLATFORM_MODERNISATION_HEADER}`
export const PLATFORM_MODERNISATION_MEGANAV = "platform_modernisation_meganav"

export const DEPENDENCIES_PRELOADVENDOR = "preloadvendor"
export const DEPENDENCIES_BUNDLEVENDOR = "bundlevendor"

export const LOADABLE_NAMESPACE = "HDR"
export const TESTING_VARIANT_KEY = "testing"

export const AXE_CONFIGURATION = Object.freeze({
    // Rule descriptions can be found here: https://github.com/dequelabs/axe-core/blob/master/doc/rule-descriptions.md
    rules: [
        {
            id: "color-contrast",
            enabled: false,
        },
    ],
})

export const BURGER_MENU_TRANSITION_DURATION = 300

export const SEO_IGNORE_LINK_REGEX = /^\/([A-Za-z]{2}|[A-Za-z]{2}\/[A-Za-z]{2})\/dummy$/
export const SEO_IGNORE_LINK = "/dummy"
export const DEV_HEADER_SERVER_PORT = 3020

export const TABBED_NAVIGATION_COOKIE_NAME = "tabbed_nav"
export const TABBED_NAVIGATION_COOKIE_DEFAULT_VALUE = "default"
export const TABBED_NAVIGATION_COOKIE_TABBED_VALUE = "tab"

export const CONTENT_TYPE = "Content-Type"
export const MULTIPART_FORM_DATA = "multipart/form-data"
export const DEV_AND_UAT_DOMAIN = "test.ecomm.systems.next"
export const TABBED_NAVIGATION_API_QUERY_PARAMETER_NAME = "tabbedDepartment"

export const LINK_CATEGORY_NAV_BAR_ICON = "NavBar Icon"
export const LINK_CATEGORY_NAV_BAR_NAME = "NavBar"
export const CUSTOM_BREAKPOINT_TABBED_NAVIGATION = 1200

export const HEADER_UI_CACHE_TAG = "header-ui"
export const SECONDARY_NAV_CACHE_TAG = "secondary-nav"
export const EMBEDDED_SEO_CACHE_TAG = "embedded-seo"
export const EMBEDDED_SEO_CACHE_TAG_CLIENT = `${EMBEDDED_SEO_CACHE_TAG}-client`

export const UCM_ONSITE_CONSENT = "OptUCMOnsiteConsent"

export const SEARCH_BOX_NAME = "w"

export const PERSONALISATION_SESSION_STORAGE_KEY = "personalisation"
export const REALTIME_API_PATH = "/api/realtime"
export const PERSONALISATION_ANON_ENDPOINT = "personalisation-anon/"
export const PERSONALISATION_ENDPOINT = "personalisation/"
export const PERSONALISATION_ERROR_RESPONSE = "PRS_ERROR_RESPONSE"
export const PERSONALISATION_LOADING = "PRS_LOADING"

export const ENRICHED_SEARCH = "EnrichSearch"
export const SIMPLE_SEARCH = "SimpleSearch"
export const AUTOCOMPLETE_DEFAULT_ITEMS = 10
export const RECENT_SEARCHES_DEFAULT_ITEMS = 6
export const TPLITE_CLIENT_EMPTY = "UNSET - LEAVE EMPTY"
// 3:4 Imagery and Image Manager
export const IMAGE_RESIZE_QUERY_STRING = "?im=Resize,width={px}"

export const SECURE_HEADER_QUERY_STRING = "secure"
export const SECURE_HEADER_VARIANT = "secure"
export const COUNTRY_SELECTOR_REDIRECT_QUERY_STRING = "isRedirectFromCountrySelect"
export const HTTPS_PROTOCOL = "https:"

// Management of this LD / here / Template level to be confirmed
export const XXL_BREAKPOINT_MAX = 1840

export enum MESSAGE_BANNER_TYPE {
    PLACEMENT_TOP_BANNER = "topBanner",
    TEASER_TYPE = "teaser",
    PERSONALISED_CONTENT_TYPE = "personalizedContent",
}

export const HEADER = "header"
export const TERTIARY_LINK = "tertiary-link"
export const TERTIARY_NAV_SLIDE_ANIMATION_DURATION = 300
export const MAX_SECONDARY_NAV_COLUMNS_WING_TEMPLATE = 5

// Auto complete product images in px
export const PRODUCT_WIDTH = 150
export const IMAGE_GAP = 24
export const STARTING_PADDING = 16
